import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {grupoService} from '../../services/grupo.service'; // Importar el servicio de grupo
import NotificationModal from '../modal/notifications-modal'; // Importa el componente del modal

function PasswordChangeModal({ open, onClose, onSave }) {
  const [correo, setCorreo] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
const [modalType, setModalType] = useState('info'); // Tipo de alerta
const [notificationOpen, setNotificationOpen] = useState(false); // Estado para el modal de notificación


const handleSave = async () => {
  // Validar los campos antes de enviar
  if (!correo || !currentPassword || !newPassword) {
    setModalMessage('Por favor, completa todos los campos.');
    setModalType('warning');
    setNotificationOpen(true);
    return;
  }

  // Crear el objeto con la estructura adecuada
  const infoUsers = {
    correo,
    currentPassword,
    newPassword,
  };

  try {
    // Llamar a la función de cambio de contraseña
    const response = await grupoService.ChangePasswordUser(infoUsers);
    
    if (response.success) {
      setModalMessage(response.message);
      setModalType('info'); // Cambiar el tipo a info en caso de éxito
    } else {
      setModalMessage(response.error);
      setModalType('error'); // Cambiar el tipo a error en caso de falla
    }
  } catch (error) {
    setModalMessage('Ocurrió un error al cambiar la contraseña.');
    setModalType('error');
  } finally {
    setNotificationOpen(true); // Mostrar el modal de notificación
    setCorreo('');
    setCurrentPassword('');
    setNewPassword('');
    onClose(); // Cerrar el modal de cambio de contraseña
  }
};

  // Función para alternar la visibilidad de la contraseña actual
  const handleClickShowCurrentPassword = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  // Función para alternar la visibilidad de la nueva contraseña
  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Cambiar Contraseña</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Correo Electrónico"
            type="email"
            fullWidth
            variant="outlined"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Contraseña Actual"
            type={showCurrentPassword ? 'text' : 'password'}
            fullWidth
            variant="outlined"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowCurrentPassword}
                    edge="end"
                  >
                    {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="Nueva Contraseña"
            type={showNewPassword ? 'text' : 'password'}
            fullWidth
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowNewPassword}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleSave} color="primary" variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Modal de notificación */}
      <NotificationModal
        open={notificationOpen}
        onClose={() => setNotificationOpen(false)}
        message={modalMessage}
        type={modalType}
      />
    </>
  );
}

export default PasswordChangeModal;